import React from "react"
import styled from "@emotion/styled"

const HeaderElement = styled.div`
    padding: 32px 32px;

    color: rgb(220, 220, 220);
`

const Title = styled.div`
    margin-bottom: 22px;

    font-size: 24px;
    font-weight: 600;
`

const Description = styled.div`
    display: block;

    max-width: 370px;

    font-size: 16px;
    line-height: 1.5em;
`

const Link = styled.a`
    margin-top: 8px;

    color: rgb(150, 150, 150);
    text-decoration: none;
    
    &:hover {
        text-decoration: underline;
    }
`

export default () => {
    return (
        <HeaderElement>
            <Title>sslsv-demo</Title>
                
            <Description>
                Speaker Verification (SV) demo based on a model trained with Self-Supervised Learning (SSL) without any labeled data.
                {' '}
                <Link target="_blank" rel="noopener noreferrer" href="https://github.com/theolepage/sslsv">See on GitHub</Link>
            </Description>
        </HeaderElement>
    )
}